// extracted by mini-css-extract-plugin
export var childPages = "Article-module--childPages--nAv4t";
export var footer = "Article-module--footer--C8Kub";
export var siblingPages = "Article-module--siblingPages--oe0EA";